import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { findIndex, map } from 'lodash';
import { observer } from 'mobx-react-lite';
import './index.less';
import { Tag, Theme } from '@emooa/ui';

type Props = {
  tags: API.MenuItem[];
  remove: Function;
};
export default observer((props: Props) => {
  const ref = useRef<any>(HTMLDivElement);
  const location = useLocation();
  const navigate = useNavigate();

  const { tags = [], remove } = props;

  useEffect(() => {
    setTimeout(() => {
      const index = findIndex(tags, { key: location.pathname });
      if (ref.current) {
        const activeTabElement = ref.current.children?.[index];
        activeTabElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }, 300);
  }, [tags]);

  const { token } = Theme.useToken();

  return (
    <div
      className="link-tags pt-0.5 pl-4 pb-0.5 pr-4"
      style={{
        background: token.colorBgBase,
        marginBottom: 2,
        boxShadow: '0 1px 3px 0 #d8dce5',
        overflow: 'auto',
        display: 'flex',
        columnGap: 8,
      }}
      ref={ref}
    >
      {map(tags, (item: API.MenuItem) => (
        <Tag
          size="mini"
          bordered
          key={item.key}
          closable={item.key !== '/'}
          color={item.key === location.pathname ? token.colorPrimary : ''}
          className="pt-0.5 pb-0.5 rounded-none"
          onClose={() => {
            remove(item);
          }}
        >
          <div onClick={() => navigate(`${item.key}${item.query || ''}`)}>
            {item.key === location.pathname && <span className="mr-1">●</span>}
            {item.label}
          </div>
        </Tag>
      ))}
    </div>
  );
});
